import React from 'react';

const SortIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M20 22.5H11C10.4 22.5 10 22.9 10 23.5C10 24.1 10.4 24.5 11 24.5H20V22.5ZM29 16.5H20.5V18.5H29C29.6 18.5 30 18.1 30 17.5C30 16.9 29.6 16.5 29 16.5ZM16.5 15C15.5 15 14.6 15.6 14.2 16.5H11C10.4 16.5 10 16.9 10 17.5C10 18.1 10.4 18.5 11 18.5H14.2C14.6 19.4 15.5 20 16.5 20C17.9 20 19 18.9 19 17.5C19 16.1 17.9 15 16.5 15ZM29 22.5H26.3C25.9 21.6 25 21 24 21C22.6 21 21.5 22.1 21.5 23.5C21.5 24.9 22.6 26 24 26C25 26 25.9 25.4 26.3 24.5H29C29.6 24.5 30 24.1 30 23.5C30 22.9 29.6 22.5 29 22.5Z" fill="white" fillOpacity="0.5" />
    </svg>
  );
};

export default SortIcon;